import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import HowItWorks from '../components/HowItWorks';
import Operations from '../components/Operations';
import FeatureBlocks from '../components/FeatureBlocks';
import NetworkGraph from '../components/NetworkGraph';
import Forecast from '../components/Forecast';
import AnyDevice from '../components/AnyDevice';
import Footer from '../components/Footer';
import ForwardDeployed from '../components/ForwardDeployed';
import FlyingRobots from '../components/FlyingRobots';
import AgentShowcase from '../components/AgentShowcase';
import useScrollReveal from '../hooks/useScrollReveal';

export default function Landing() {
  useScrollReveal([]);

  useEffect(() => {
    const onMove = (e) => {
      document.documentElement.style.setProperty('--mx', `${e.clientX}px`);
      document.documentElement.style.setProperty('--my', `${e.clientY}px`);
    };
    const onScroll = () => {
      const h = document.documentElement.scrollHeight - window.innerHeight;
      const p = h > 0 ? (window.scrollY / h) * 100 : 0;
      document.documentElement.style.setProperty('--sp', `${p}%`);
    };
    window.addEventListener('mousemove', onMove);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => {
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  return (
    <div className="bg-[#050506] text-white relative">
      <div className="scroll-progress" />
      <FlyingRobots />
      <Navbar />
      <Hero />
      <div className="reveal"><HowItWorks /></div>
      <div className="reveal"><Operations /></div>
      <div className="reveal"><FeatureBlocks /></div>
      <div className="reveal"><AgentShowcase /></div>
      <div className="reveal"><NetworkGraph /></div>
      <div className="reveal"><Forecast /></div>
      <div className="reveal"><ForwardDeployed /></div>
      <div className="reveal"><AnyDevice /></div>
      <Footer />
    </div>
  );
}
